import { BehaviorSubject, Subject } from 'rxjs';
import { CODE_ENV_LIST } from '@/common/constants/ConstCode';
let instance;

export class DynamicLinkManager {
  #dynamicSubject = new BehaviorSubject('');

  #pendingPushTarget = null;

  #pushGeneration = 0;

  #inFlightPushTargets = new Map();

  #pushOptions = null;

  #subscribeMethod = () => {};
  // online = () => {
  //   this.#dynamicSubject.subscribe(this.#subscribeMethod);
  // };
  initialize = async (method = () => {}) => {
    // this.#subscribeMethod = method;
    this.#dynamicSubject.subscribe(method);
    console.warn('DynamicLinkManager 등록 완료');
    return true;
  };

  initializePush = async (options = {}) => {
    this.#pushOptions = options;
    return this.replayPendingPush();
  };

  #normalizePushTarget = (callbackParams) => {
    let roomNo;
    let type;

    if (typeof callbackParams === 'string') {
      const match = callbackParams.match(/^\/room\/([^/]+)\/([^/]+)$/);
      if (!match) return null;
      [, roomNo, type] = match;
    } else if (callbackParams && typeof callbackParams === 'object') {
      ({ roomNo, type } = callbackParams);
    } else {
      return null;
    }

    const isIntegerText = typeof roomNo === 'string' && /^[0-9]+$/.test(roomNo);
    const normalizedRoomNo = typeof roomNo === 'number' || isIntegerText ? Number(roomNo) : NaN;
    if (!Number.isSafeInteger(normalizedRoomNo) || normalizedRoomNo <= 0) return null;
    if (type !== 'ORDER' && type !== 'INQUIRY') return null;

    return {
      roomNo: normalizedRoomNo,
      type,
      path: `/room/${normalizedRoomNo}/${type}`
    };
  };

  #isAuthenticated = () => Boolean(this.#pushOptions?.isAuthenticated?.());

  #processPushTarget = async (target) => {
    const currentTarget = this.#normalizePushTarget(this.#pushOptions?.getCurrentPath?.());
    const isSameRoom =
      currentTarget?.roomNo === target.roomNo && currentTarget?.type === target.type;

    if (isSameRoom) {
      const chat = this.#pushOptions?.getChatRoomState?.();
      if (
        Number(chat?.desiredRoomNo) !== target.roomNo ||
        Number(chat?.subscribedRoomNo) !== target.roomNo ||
        Number(chat?.selectedRoom?.roomNo) !== target.roomNo
      ) return null;
      if (await this.#pushOptions?.resync?.(target) === false) return null;
    } else {
      const navigationResult = await this.#pushOptions?.navigate?.(target.path);
      if (navigationResult !== undefined || this.#pushOptions?.getCurrentPath?.() !== target.path) {
        return false;
      }
    }

    return true;
  };

  #runPushTarget = (target, generation) => {
    const existing = this.#inFlightPushTargets.get(target.path);
    if (existing && !existing.settled) return existing.promise;

    const entry = { generation, settled: false, promise: null };
    const operation = this.#processPushTarget(target)
      .then((processed) => {
        entry.settled = true;
        if (entry.generation === this.#pushGeneration && processed !== false) {
          this.#pendingPushTarget = null;
        }
        return processed === true;
      })
      .catch(() => {
        entry.settled = true;
        if (entry.generation === this.#pushGeneration) this.#pendingPushTarget = target;
        return false;
      })
      .finally(() => {
        if (this.#inFlightPushTargets.get(target.path) === entry) {
          this.#inFlightPushTargets.delete(target.path);
        }
      });
    entry.promise = operation;
    this.#inFlightPushTargets.set(target.path, entry);
    return operation;
  };

  doPushAction = async (callbackParams) => {
    const target = this.#normalizePushTarget(callbackParams);
    if (!target) return false;

    if (!this.#pushOptions || !this.#isAuthenticated()) {
      this.#pushGeneration += 1;
      this.#pendingPushTarget = target;
      return false;
    }

    const existing = this.#inFlightPushTargets.get(target.path);
    if (existing && !existing.settled) {
      if (existing.generation !== this.#pushGeneration) {
        existing.generation = ++this.#pushGeneration;
        this.#pendingPushTarget = target;
      }
      return existing.promise;
    }

    const generation = ++this.#pushGeneration;
    this.#pendingPushTarget = target;
    return this.#runPushTarget(target, generation);
  };

  replayPendingPush = async () => {
    if (!this.#pushOptions || !this.#isAuthenticated() || !this.#pendingPushTarget) return false;

    const target = this.#pendingPushTarget;
    return this.#runPushTarget(target, this.#pushGeneration);
  };

  #normalizeDynamicLink = (link = '') => {
    const rawLink = String(link ?? '');
    let path = rawLink;

    if (/^https?:\/\//i.test(rawLink)) {
      try {
        const url = new URL(rawLink);
        const allowedOrigins = [CODE_ENV_LIST.FILE_SERVER_URL, CODE_ENV_LIST.DYNAMIC_DOMAIN]
          .filter(Boolean)
          .map((domain) => new URL(domain).origin);
        if (!allowedOrigins.includes(url.origin)) return '/main';

        path = `${url.pathname}${url.search}`;
      } catch {
        return '/main';
      }
    } else {
      path = rawLink.replace(CODE_ENV_LIST.FILE_SERVER_URL, '').replace(CODE_ENV_LIST.DYNAMIC_DOMAIN, '');
    }

    const [, routePath = '', queryString = ''] = path.match(/^([^?]*)(\?.*)?$/) ?? [];
    const storeMatch = routePath.match(/^\/link\/dynamicLink\/store\/([^/]+)$/);
    if (storeMatch) return `/shop/${storeMatch[1]}/product`;

    const productMatch = routePath.match(/^\/link\/dynamicLink\/product\/([^/]+)\/([^/]+)$/);
    if (productMatch) return `/shop/${productMatch[1]}/product/${productMatch[2]}`;

    if (routePath === '/link/dynamicLink/search') return `/search${queryString}`;

    return path;
  };

  doDynamicAction = (link) => {
    // console.log('doDynamicAction link path ::', link);
    this.#dynamicSubject.next(this.#normalizeDynamicLink(link));
  };
}
export default (() => {
  if (!instance) instance = new DynamicLinkManager();
  return instance;
})();
